import script from "./FirstPageDemandList.vue?vue&type=script&setup=true&lang=js"
export * from "./FirstPageDemandList.vue?vue&type=script&setup=true&lang=js"

import "./FirstPageDemandList.vue?vue&type=style&index=0&id=0530fd9d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0530fd9d"]])

export default __exports__